import { Routes } from '@angular/router';

// Every route is lazy-loaded. These components are large - booking alone is
// ~7,500 lines - and eagerly importing them all put every screen in the initial
// bundle, so a customer opening a booking link also downloaded memberships,
// vouchers, waivers and the manage-booking portal before the page could render.
//
// loadComponent works here because all of these are standalone components and
// none of them import one another; if that ever changes, the imported one gets
// pulled back into its importer's chunk and the split silently degrades.

export const routes: Routes = [
      {
        path: 'managebooking/:id/:bookingid',
        loadComponent: () => import('./managebooking2/managebooking2').then(m => m.Managebooking2),
      },
      {
        path: 'managewaiver/:id',
        loadComponent: () => import('./managewaiver/managewaiver.component').then(m => m.ManagewaiverComponent),
      },
      {
        path: 'completewaiver/:id/:bookingid',
        loadComponent: () => import('./completewaiver/completewaiver.component').then(m => m.CompletewaiverComponent),
      },
      {
        path: 'completewaiver/:id/:external/:type',
        loadComponent: () => import('./completewaiver/completewaiver.component').then(m => m.CompletewaiverComponent),
      },
      {
        path: '',
        loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
      },
      {
        path: 'booking/:venue',
        loadComponent: () => import('./booking/booking.component').then(m => m.BookingComponent),
      },
      {
        path: 'booking/:venue/:date',
        loadComponent: () => import('./booking/booking.component').then(m => m.BookingComponent),
      },
      {
        path: 'booking/:venue/:title/:desc/:url/:image',
        loadComponent: () => import('./booking/booking.component').then(m => m.BookingComponent),
      },
      {
        path: 'events/:venue',
        loadComponent: () => import('./events-list/events-list.component').then(m => m.EventsListComponent),
      },
      {
        path: 'terms/:venue',
        loadComponent: () => import('./terms/terms.component').then(m => m.TermsComponent),
      },
      {
        path: 'payment',
        loadComponent: () => import('./payment/payment.component').then(m => m.PaymentComponent),
      },
      {
        path: 'subscriptions',
        loadComponent: () => import('./subscribethanks/subscribethanks.component').then(m => m.SubscribethanksComponent),
      },
      {
        path: 'buyvoucher/:venue',
        loadComponent: () => import('./buyvoucher/buyvoucher.component').then(m => m.BuyvoucherComponent),
      },
      {
        path: 'buymembership/:venue',
        loadComponent: () => import('./memberships/memberships.component').then(m => m.MembershipsComponent),
      }
];
